<template>
	<div class="mobeil_page flex-col">
		<div class="mobeil_group_1 flex-col align-center">
			<!--顶部导航栏-->
			<div class="mobeil_box_1 flex-col">
				<div class="mobeil_group_2 flex-row align-center flexXSpaceBetween pt-5 pb-5 pl-10 pr-10">
					<span class="cnBold f22">镇江鑫飞扬网络科技有限公司</span>
					<img @click="showNavigation = !showNavigation" style="width: 25px;height: 20px"
						 src="./assets/img/more.png" alt="">
				</div>
				<div class="navigation_container flexXSpaceBetween cnBold
				pl-10 pr-10 font-bold" :class="[showNavigation ? 'navigation_active' : '']"
					 style="color: rgba(97, 135, 173, 1);">
					<div @click="clickTabIndex(0,'scroll0')">
						首页
					</div>
					<div @click="clickTabIndex(1,'scroll1')">
						授权品牌
					</div>
					<div @click="clickTabIndex(2,'scroll2')">
						关于我们
					</div>
					<div @click="clickTabIndex(3,'scroll3')">
						联系我们
					</div>
				</div>
			</div>
			<!--主页-->
			<div id="scroll0" class="flex-col align-center" style="width: 100%;" v-show="tabSelectIndex === 0">
				<img id="scroll6" class="image_7 w-full" referrerpolicy="no-referrer"
					 src="./assets/img/index.png"/>
				<span class="f34 f-blue mt-20 cnHeavy">宗旨</span>
				<div class="flex-col flexYCenter w-full pl-15 pr-15">
					<span class="f21 f-blue word-break w-full cnHeavy">
						让热爱触手可及
						全球正版动漫生态领创者
					</span>
					<span class="f15 text-center f-blue word-break font-normal">
						——以二次元文化为纽带，链接全球超百万用户，打造集收藏、娱乐、社交于一体的沉浸式体验平台。
					</span>
				</div>
				<swiper class="swiper_container mt-20" ref="mySwiper" :options="swiperOptions">
					<swiper-slide class="swiper_item" v-for="(item,i) in swiperList" :key="i">
						<img :src="item" alt="">
					</swiper-slide>
					<!--<div class="swiper-pagination" slot="pagination"></div>-->
				</swiper>
				<div class="flex-col flexYCenter pl-15 pr-15 mt-20">
					<span class="f15 text-center f-blue word-break font-normal">
						涵盖变形金刚、高达、日漫手办等近万种授权商品，从经典IP到新锐潮玩，全线产品通过官方正版认证，
						为收藏价值与艺术品质提供双重保证
					</span>
				</div>
			</div>

			<!--授权品牌-->
			<div id="scroll1" class="flex-col flexYCenter mb-100" v-show="tabSelectIndex === 1">
				<img id="scroll6" class="image_7 w-full" referrerpolicy="no-referrer"
					 src="./assets/img/shouquan.png"/>
				<div class="flex-col flexYCenter pl-15 pr-15 mt-20">
					<span class="f17 text-center f-blue word-break font-normal">
						授权品牌主要分为 ​日本经典动漫IP、国内热门游戏/影视IP 及 ​原创潮玩IP 三大类，
						依托万代南梦宫、TAKILUCKY、Suplay等平台深度合作，覆盖全年龄段用户
					</span>
				</div>
			</div>

			<!--关于我们-->
			<div id="scroll2" class="flex-col flexYCenter w-full" v-show="tabSelectIndex === 2">
				<img id="scroll6" class="image_7 w-full" referrerpolicy="no-referrer"
					 src="./assets/img/about.png"/>
				<span class="f34 f-blue mt-20 cnHeavy">企业愿景</span>
				<div class="flex-col flexYCenter w-full pl-15 pr-15">
					<span class="f21 f-blue word-break w-full cnHeavy">
						「尽享娱乐!开启新生活!」
					</span>
					<span class="f15 text-center f-blue word-break font-normal">
						我们的目标是带来只能在线亲身体验的丰富娱乐。
						我们重视只有在这里才能感受到的乐趣和兴奋，并希望创造一个玩家可以更加平等地互动和玩耍的环境。
						我们致力于重新定义娱乐的概念，并将真实的体验带到网上
					</span>
				</div>
				<span class="f34 f-blue mt-20 cnHeavy">企业文化</span>
				<div class="flex-col flexYCenter w-full pl-15 pr-15">
					<span class="f21 f-blue word-break w-full cnHeavy">
						「以惊喜重塑热爱，用概率传递快乐」
					</span>
					<span class="f15 text-center f-blue word-break font-normal">
						通过透明化概率机制与正版IP结合，打破传统盲盒的消费不确定性，
						让玩家以可控成本享受 ​​“小投入、高惊喜”​ 的收藏体验，
						构建跨越年龄、地域的次元文化共同体
					</span>
				</div>
			</div>

			<!--联系我们-->
			<div id="scroll3" class="flex-col flexYCenter w-full" v-show="tabSelectIndex === 3">
				<img id="scroll6" class="image_7 w-full" referrerpolicy="no-referrer"
					 src="./assets/img/location.png"/>
				<div class="mt-20 flex-col flexYCenter w-full pl-15 pr-15">
					<span class="f24 f-blue cnBold text-left w-full">「反馈问题」</span>
					<div class="block_6 w-full" style="height: 200px">
						<textarea v-model="userContent" class="text_38 f18" placeholder="请输入您要反馈的问题"></textarea>
					</div>
					<span class="f24 f-blue cnBold text-left mt-20 w-full">「联系方式」</span>
					<div class="text-wrapper_21 flex-col w-full" style="height: 50px;">
						<input v-model="userEmail" placeholder="邮件地址"
							   class="f18"
							   style="width: calc(100% - 20px);height: calc(100% - 10px);margin: 5px;
							   border: none;outline: none"/>
						<span v-if="emailError" style="color: red;margin-top: 12px;">请输入有效的电子邮件地址</span>
					</div>

					<button class="flexYCenter flexXCenter  w-half pt-10 pb-10 mt-20"
							style="background-color: rgba(40, 92, 144, 1);border-radius: 10px"
							@click="clickSend()">
						<span class="color-white cnBold f22">发送</span>
					</button>
				</div>
			</div>
			<!--简介-->
			<div class="flexXSpaceBetween flexWrap bg-color-black w-full pl-10 pr-10 mt-80 pb-10">
				<span class="text_44 w-full mt-20">镇江鑫飞扬网络科技有限公司</span>
				<div class="flex-col justify-between w-full">
					<span class="paragraph_21">
							‌镇江鑫飞扬网络科技有限公司—— 专注网络技术，驱动企业数字化未来
						<br/>
‌公司概览‌
镇江鑫飞扬网络科技有限公司成立于2022年2月17日，总部位于江苏省镇江市京口区电力路199号迎江大厦1013室，是一家以网络技术研发与互联网服务为核心的高科技企业‌
						公司深耕本地市场，辐射长三角地区，致力于为企业提供智能化解决方案与数字化转型支持。
						<br/>
‌核心业务领域‌
• ‌网络技术开发‌：涵盖软件开发、系统集成及技术咨询服务，助力企业实现信息化升级‌；
• ‌互联网平台运营‌：聚焦流量聚合与商业策划，为实体行业提供线上线下融合的解决方案‌；
• ‌企业服务支持‌：包括网站设计、数据安全维护及服务器托管，覆盖全生命周期技术服务‌。
						<br/>
‌竞争优势‌
‌技术能力‌：团队具备自主研发能力，曾参与开发行业领先的流量整合系统与智能管理平台‌；
‌本地化服务‌：扎根镇江京口区，熟悉区域产业需求，与多家本地企业建立长期合作关系‌；
‌敏捷响应‌：依托灵活的服务模式，快速响应客户需求，累计完成中小型项目超50例‌。
						<br/>
‌社会责任‌
公司积极推动“技术赋能实体”理念，通过数字化工具帮助传统商超提升运营效率，助力区域经济可持续发展‌。
						<br/>
‌发展愿景‌
未来三年，公司将深化人工智能与大数据技术应用，目标成为镇江地区领先的数字化转型服务商，并逐步拓展至智慧城市领域‌。
						</span>
				</div>
				<div class="line-white w-full"></div>
				<div class="paragraph_21 flexYCenter flexXCenter w-full mt-5">
					江苏省镇江市京口区电力路199号迎江大厦1013室
					<br/>
					zzyljj9192@163.com
					<br/>
					版权所有 © 镇江鑫飞扬网络科技有限公司 All Rights Reserved
					<br/>
					苏ICP备2025165347号
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
		name: 'HomeIndexMobile',
		data() {
			return {
				constants: {},
				tabSelectIndex: 0,
				selectQu: 0,
				userName: '',
				userContent: '',
				userEmail: '',
				contents: ['採用に関するお問い合わせ', '取材のお申し込み', 'サービス導入や提案などのご案内', 'その他'],
				isSend: false,
				showNavigation:false,
				swiperOptions: {
					pagination: {
						el: '.swiper-pagination'
					},
					grabCursor: true, // 手掌形状
					loop: true, // 无限循环
					slidesPerView: 1, // 每屏显示3个
					loopedSlides: 3,
					autoplay: true
				},
				swiperList: [
					require('./assets/img/swiper1.png'),
					require('./assets/img/swiper2.png'),
					require('./assets/img/swiper3.png'),
					require('./assets/img/swiper4.png'),
					require('./assets/img/swiper5.png'),
					require('./assets/img/swiper6.png'),
					require('./assets/img/swiper7.png'),
				]
			};
		},
		computed: {
			emailError() {
				// 使用正则表达式验证邮箱格式
				const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
				return this.userEmail.length > 0 && !emailPattern.test(this.userEmail);
			}
		},
		methods: {
			clickTabIndex(index, selector) {
				if (this.tabSelectIndex == index) {
					return
				}
				this.tabSelectIndex = index;
				const element = document.getElementById(selector);
				if (element) {
					element.scrollIntoView({
						behavior: 'smooth'
					});
				}
			},
			clickQu(index) {
				this.selectQu = index;
			},
			clickSend() {
				if (this.removeSpaces(this.userContent).length == 0) {
					alert('请输入您的反馈问题。');
					return;
				}

				if (this.removeSpaces(this.userEmail).length == 0) {
					alert('请输入您的邮箱。');
					return;
				}
				// 使用正则表达式验证邮箱格式
				const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
				if (!emailPattern.test(this.userEmail)) {
					alert('请输入有效的电子邮件地址');
					return;
				}

				if (this.isSend) {
					return
				}
				this.isSend = true;
				alert('已发送');

				/*axios.post('https://api-dev.treasureshub.jp/app/suggestion/send', {
					"name": this.userName, // 姓名
					"type": this.contents[this.selectQu], // 类型
					"context": this.userContent, // 内容
					"email": this.userEmail // 邮箱
				}).then(res => {
					alert('送信完了');
					console.log(res);
				}).catch(error => {
					console.error('请求用户数据出错:', error);
				});*/
			},
			removeSpaces(str) {
				return str.replace(/\s+/g, '');
			}
		}
	};
</script>
<style lang='scss'>
*{
	box-sizing: border-box;
}
	@import './assets/indexMobile.css';
	@import '../assets/common.css';
	.navigation_container{
		opacity: 0;
		height: 0;
		transition: all 0.3s ease;
	}
	.navigation_active{
		opacity: 1;
		height: 22px;
		transition: all 0.3s ease;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.f-blue{
		color: rgba(24, 63, 102, 1);
	}
	.cnHeavy{
		font-family: SourceHanSansCN-Heavy;
	}
	.cnBold{
		font-family: SourceHanSansCN-Bold;
	}
.swiper_container {
	width: 100%;
	.swiper_item {
		img {
			height: 250px;
			width: auto;
		}
	}
}
</style>
